import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Guides = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Guides Paris Sportifs</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <p className="text-gray-700 text-lg leading-relaxed">
              Que vous soyez débutant ou parieur expérimenté, nos guides vous aident à comprendre 
              les <strong>paris sportifs</strong> et à améliorer vos stratégies de mise.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Guide du débutant</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">1. Comprendre les cotes</h3>
                <p className="text-gray-700">
                  Les cotes représentent la probabilité d'un événement et déterminent vos gains potentiels. 
                  En France, on utilise les cotes décimales. Une cote de 2.00 signifie que vous doublez 
                  votre mise en cas de victoire. Plus la cote est élevée, plus l'événement est considéré 
                  comme improbable.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">2. Types de paris</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>Pari simple :</strong> Un seul événement, le plus sûr pour débuter</li>
                  <li><strong>Pari combiné :</strong> Plusieurs événements combinés, cotes multipliées</li>
                  <li><strong>Pari système :</strong> Combinaisons multiples pour sécuriser les gains</li>
                  <li><strong>Pari live :</strong> Pariez en direct pendant le match</li>
                </ul>
              </div>
              
              <div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">3. Les marchés de paris</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>1X2 :</strong> Victoire équipe 1, Match nul, Victoire équipe 2</li>
                  <li><strong>Over/Under :</strong> Plus ou moins de X buts/points</li>
                  <li><strong>Handicap :</strong> Avantage virtuel donné à une équipe</li>
                  <li><strong>Mi-temps/Fin de match :</strong> Score à la mi-temps et final</li>
                  <li><strong>Buteur :</strong> Pariez sur le(s) buteur(s) du match</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Stratégies de base</h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-gray-50 rounded-lg p-5">
                <h3 className="font-semibold text-gray-900 mb-2">Gestion de bankroll</h3>
                <p className="text-gray-600 text-sm">
                  Définissez un budget dédié aux paris et ne le dépassez jamais. 
                  Ne misez jamais plus de 5% de votre bankroll sur un seul pari.
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-5">
                <h3 className="font-semibold text-gray-900 mb-2">Value betting</h3>
                <p className="text-gray-600 text-sm">
                  Recherchez les cotes sous-évaluées par les bookmakers. 
                  Pariez quand vous estimez que la probabilité réelle est supérieure à celle des cotes.
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-5">
                <h3 className="font-semibold text-gray-900 mb-2">Spécialisation</h3>
                <p className="text-gray-600 text-sm">
                  Concentrez-vous sur un sport ou une ligue que vous connaissez bien. 
                  L'expertise approfondie augmente vos chances de succès.
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-5">
                <h3 className="font-semibold text-gray-900 mb-2">Comparaison des cotes</h3>
                <p className="text-gray-600 text-sm">
                  Les cotes varient entre bookmakers. Avoir plusieurs comptes permet 
                  de toujours parier à la meilleure cote disponible.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Erreurs à éviter</h2>
            <div className="bg-red-50 border border-red-200 rounded-lg p-6">
              <ul className="text-red-700 space-y-2">
                <li>❌ Parier pour se refaire après une perte (chasing)</li>
                <li>❌ Miser sur son équipe favorite par émotion</li>
                <li>❌ Négliger l'analyse et parier au hasard</li>
                <li>❌ Accumuler trop de sélections en combiné</li>
                <li>❌ Ignorer les statistiques et la forme des équipes</li>
                <li>❌ Parier sous l'influence de l'alcool</li>
              </ul>
            </div>
          </section>

          <section className="bg-green-50 border border-green-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-green-800 mb-3">Clés du succès</h2>
            <ul className="text-green-700 space-y-2">
              <li>✅ Patience et discipline</li>
              <li>✅ Analyse approfondie avant chaque pari</li>
              <li>✅ Tenue d'un historique de vos paris</li>
              <li>✅ Acceptation des pertes comme partie du jeu</li>
              <li>✅ Formation continue et veille sportive</li>
            </ul>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Guides;
